var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppVersion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "app_version_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 37.7 49.3",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".app_version_svg__st1{fill:#949499}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2 0H6.6C2.9 0 0 2.9 0 6.6v36.1c0 3.6 2.9 6.6 6.6 6.6h15.6c3.6 0 6.6-2.9 6.6-6.6V6.6c0-3.7-3-6.6-6.6-6.6m-7.8 1.7c.9 0 1.6.7 1.6 1.6s-.7 1.6-1.6 1.6c-.9 0-1.6-.7-1.6-1.6s.7-1.6 1.6-1.6m0 46.6c-1.4 0-2.6-1.2-2.6-2.6 0-1.4 1.2-2.6 2.6-2.6s2.6 1.2 2.6 2.6c0 1.5-1.1 2.6-2.6 2.6m10.4-6.1H4V6.9h20.7l.1 35.3z",
    fill: "#999",
    id: "app_version_svg__Layer_1-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "app_version_svg__st1",
    d: "M21.9 15.7c.6 0 1.2-.7 1.2-1.5V3.8c0-1.9-1.2-3.5-2.7-3.5H3C1.5.3.3 1.9.3 3.8v41.9c0 1.9 1.2 3.5 2.7 3.5h17.3c1.5 0 2.7-1.6 2.7-3.5v-1.2L15.4 39h-13V3.9h18.2v10.3c.1.9.6 1.5 1.3 1.5zM8.1 42.6h7.3v2.6H8.1v-2.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "app_version_svg__st1",
    d: "M22.4 23.5s6.5-3.6 7.8-4.4c1.3-.7 2.3-.7 3.3 1.1s2.8 6.1 3.3 7.3c.5 1.2 2.1 6.1-1 8.8s-4.8 4.2-6 4.8c-1.2.7-3.9 1.4-7.2-.7s-5-3.2-6-4-2-2.5-1-4.5c1-2.1 2.7-1 3.3-.5l3.1 1.9s-7-15.1-7.4-16.2-.6-2.6.5-3.6c.9-.9 2.2-.6 2.9.6.6 1.2 4.4 9.4 4.4 9.4z"
  })));
}
export default SvgAppVersion;